<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.5)"
  size="medium"
  color="#ddd"
  type="ball-scale-multiple"
  [fullScreen]="true">
  <p style="color: white">Cargando... </p>
</ngx-spinner>
<router-outlet></router-outlet>
